<mat-toolbar class="mkt-navbar colorful-mat-toolbar">
  <span class="example-spacer"></span>
  <div class="mkt-navbar-options" fxLayout="row" fxLayoutGap="30px" fxLayoutAlign="end center">
    <button class="nav-button" mat-button routerLink="/Certificates/Certificateorigin" routerLinkActive="active-route">
      {{ 'certificates.navbar.certificates-origin' | translate }}
    </button>
  </div>
</mat-toolbar>
